<script>
export default {
    name: "BaseSbpIcon"
}
</script>

<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.19819 12.139L5.39319 13.7563L2.79053 18.2632L13.4075 12.139H8.19819Z" fill="#874691"/>
        <path d="M16.2124 7.52124L13.4074 9.1385L10.8047 13.6454L21.4177 7.52124H16.2124Z" fill="#DA1844"/>
        <path d="M13.4074 5.90388L10.8047 1.39697V10.6367V13.6453V22.8851L13.4074 18.3782V5.90388Z" fill="#F9B229"/>
        <path d="M10.8047 1.39697L13.4074 5.90388L16.2124 7.52114H21.4177L10.8047 1.39697Z" fill="#F07F1A"/>
        <path d="M10.8047 10.6368V22.8852L13.4074 18.3783V15.1398L10.8047 10.6368Z" fill="#72B22C"/>
        <path d="M16.2124 16.7611L13.4074 18.3784L10.8047 22.8853L21.4177 16.7611H16.2124Z" fill="#00743E"/>
        <path d="M2.79053 6.01477V18.2631L5.39319 13.7562V10.5217L2.79053 6.01477Z" fill="#5F5A94"/>
        <path d="M10.8048 10.6366V10.6406L2.79053 6.01477L5.39319 10.5217L16.2125 16.7608H21.4178L10.8048 10.6366Z" fill="#0D90CD"/>
    </svg>
</template>

<style scoped>

</style>
